/*
 * Setup the namespace for this logic
 */
var addRosterEntryExcluder = addRosterEntryExcluder || {};

/*
 * The Building Questionnaire page was throwing a "Object doesn't support
 *   property or method 'select'" when the "Edit" button was pushed in the
 *   grid for IE in Compatibility Mode.
 * Since the 'Add' button is never displayed on the 'Roster Entry' view of
 *   the page adding a check to ensure the function is available should do
 *   the trick and not have any negative adverse effects to that page or
 *   the GL page (which also uses this JS).
 */
addRosterEntryExcluder.initialize = function() {
	ap.consoleInfo("addRosterEntryExcluder initialize!");

	var addButton = $("input#rosterAddNewBtn")[0];
	if (addButton) {
		addButton.style.display = "none";
	}
};